module.exports = __webpack_public_path__ + "static/media/rating.ba5d8072.jpg";